import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum DuluxEventTypes {
    "Enquiry" = "689fdc35-c84d-453f-a7ad-852ae108d0c9",
    "Onboarding" = "880cd565-c763-442d-900b-b356d51bfc3c",
    "Calls" = "f192a6ae-cf1f-4fe0-80f2-0c030de95614",
    "Leads" = "f2f58103-6ed6-4e88-a0e2-2fde13258bf8",
    "Appointments" = "2b823b69-7ce3-4f9d-9d25-133965e6c6be",
    "BlueStoreEnquiries" = "4c9e86a6-fecb-410e-b556-98c60b91611e",
    "BlueStoreCalls" = "a1611de9-d521-4b4a-b6dd-1f87d6187ba6",
    "BlueStoreWalkins" = "27f4f0d0-b0e8-4de0-98b7-533a90ef7f0a",
    "BlueStoreRfh" = "0dc2ce58-75e1-4e14-bdb2-86ab2007fbf2",
    "BlueStoreRfq" = "12e4eefa-2684-4bfd-a30c-510a4872a31a",
    "BlueStoreQuotations" = "05d0f341-1894-46ac-a5dc-053f4fb98964",
    "BlueStoreCustomQuotations" = "0724e00f-8c8f-465a-b39a-06e74c122786",
}

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const DULUX__EVENT__AID_APPOINTMENT__DISPOSITION__COLUMN_ID = "ab8b7aad-d014-4b55-af12-f7141a7efa9d" as Uuid;

export const DULUX__EVENT__AID_CALL__DISPOSITION__COLUMN_ID = "5e0d9746-39db-439e-bf8e-54fe18e27d67" as Uuid;

export const DULUX__EVENT__AID_ENQUIRY__DISPOSITION__COLUMN_ID = "29fa32eb-f096-45a6-b6fc-98b138fdf2b4" as Uuid;

export const DULUX__EVENT__AID_ONBOARDING__DISPOSITION__COLUMN_ID = "3c7c575e-4440-4e92-8848-7408afd200b9" as Uuid;

export const DULUX__EVENT__BLUE_STORE_CALLS__DISPOSITION__COLUMN_ID = "45e21797-1c1c-4cd1-b7bd-c31cce26d8e5" as Uuid;

export const DULUX__EVENT__BLUE_STORE_CUSTOM_QUOTATIONS__DISPOSITION__COLUMN_ID = "781323d5-0ad9-412c-9a81-b5b26226dc8f" as Uuid;

export const DULUX__EVENT__BLUE_STORE_ENQUIRIES__DISPOSITION__COLUMN_ID = "535227f0-c9d7-4ea1-bfdf-2a80bb38ac19" as Uuid;

export const DULUX__EVENT__BLUE_STORE_QUOTATIONS__DISPOSITION__COLUMN_ID = "3232c85f-f359-449d-8eae-25f0586bab98" as Uuid;

export const DULUX__EVENT__BLUE_STORE_RFH__DISPOSITION__COLUMN_ID = "d5242cd6-b2cb-4ee5-af10-569fa2d51847" as Uuid;

export const DULUX__EVENT__BLUE_STORE_RFQ__DISPOSITION__COLUMN_ID = "3c611da6-e5f5-4060-a0e1-14cd05b90e0d" as Uuid;

export const DULUX__EVENT__BLUE_STORE_WALKINS__DISPOSITION__COLUMN_ID = "0e9cd4b5-55ce-48f3-8da8-e74a1e290d72" as Uuid;

export const DULUX__EVENT__ENQUIRY__COMPANY_NAME__COLUMN_ID = "e108c283-1026-4f9b-b864-09da01e9eb6a" as Uuid;

export const DULUX__EVENT__ENQUIRY__PINCODE__COLUMN_ID = "c3f56952-826d-4b66-9c65-f038e1f7e5f6" as Uuid;

export const DULUX__EVENT__ENQUIRY__STATE__COLUMN_ID = "b4bdf689-74ec-4cd1-9158-ee54c0482cdf" as Uuid;

export const DULUX__EVENT__ENQUIRY__CITY__COLUMN_ID = "48c9ad34-db33-4c67-9387-1b5bba88ed60" as Uuid;

export const DULUX__EVENT__ENQUIRY__CONSENT_FOR_PERSONAL_DATA__COLUMN_ID = "26ae9b0b-87cc-44ef-8af6-ce54910dc8e1" as Uuid;

export const DULUX__EVENT__ENQUIRY__CONSENT_FOR_MARKETING_EMAIL__COLUMN_ID = "a1d1e1f0-a63e-4daa-8dfb-f4e20c4717b7" as Uuid;

export const DULUX__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID = "959e85f7-229b-4b19-9ca3-c66de0b48811" as Uuid;

export const DULUX__EVENT__ENQUIRY__EVENT_OWNER__COLUMN_ID = "830826f8-5968-4c7d-bd81-f49e65bf65b3" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID = "cca51ba5-3e52-4753-9266-bb44df341be3" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID = "6e184213-5028-4b32-80bb-6a66de5de1b7" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID = "f4f0325c-b222-491a-9c65-86c12c642063" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID = "f0aa2d0c-e4d4-444d-9b40-7dba582c483d" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID = "2fe1a9bb-2479-48ef-810f-4baaf22485ae" as Uuid;

export const DULUX__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID = "858e1023-f8d6-4cd0-9281-e67fe5ae4fb8" as Uuid;

export const DULUX__EVENT__LEADS__EVENT_OWNER__COLUMN_ID = "daf82933-c902-4dde-b049-ad3824428fa0" as Uuid;

export const DULUX__EVENT__ONBOARDING__ONBOARDING_STATUS__COLUMN_ID = "38bf482c-0c55-4217-8c2d-8f521b987a36" as Uuid;

export const DULUX__EVENT__ONBOARDING__EVENT_OWNER__COLUMN_ID = "f10a3bfb-d3ce-4d38-b89f-12562513b1e8" as Uuid;

export const DULUX__EVENT__CALLS__CALL_STATUS__COLUMN_ID = "101881ca-3c6f-4e63-a1fc-07dadf67c39d" as Uuid;

export const DULUX__EVENT__CALLS__LAST_DISPOSITION__COLUMN_ID = "4e019714-dc90-445c-a1a1-6ff582634670" as Uuid;

export const DULUX__EVENT__CALLS__CREATED_BY_ROLE__COLUMN_ID = "f45f7566-6076-4fb1-b4bb-6b6716ea4bf1" as Uuid;

export const DULUX__EVENT__CALLS__EVENT_OWNER__COLUMN_ID = "12acb0a1-25c2-40a6-88c9-5b17c232895b" as Uuid;

export const DULUX__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID = "bc26dcc4-4544-4cb0-9ae4-b0c03611a6ca" as Uuid;

export const DULUX__EVENT__CALLS__LOGGED_DATE__COLUMN_ID = "2b73f087-88cb-40ab-ad50-5af86b6ae6be" as Uuid;

export const DULUX__EVENT__CALLS__CANCELLED_BY__COLUMN_ID = "6ae0a471-9618-41b2-a0b9-3fb1061fb79e" as Uuid;

export const DULUX__EVENT__CALLS__CANCELLED_DATE__COLUMN_ID = "b947b1c4-b2b0-485c-aec7-54cb1147a6e7" as Uuid;

export const DULUX__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID = "a287d7d5-d669-4daf-9d95-f2514a8dad81" as Uuid;

export const DULUX__EVENT__CALLS__LOGGED_REMARKS__COLUMN_ID = "529f4886-252d-47f9-bd76-6af6e93a688d" as Uuid;

export const DULUX__EVENT__APPOINTMENT__APPOINTMENT_STATUS__COLUMN_ID = "a6b26c96-76b3-47c1-9368-bfa5ff3e62ee" as Uuid;

export const DULUX__EVENT__APPOINTMENT__LAST_DISPOSITION__COLUMN_ID = "78ff0963-cd39-4c9b-964d-ebf49abf315d" as Uuid;

export const DULUX__EVENT__APPOINTMENT__CREATED_BY_ROLE__COLUMN_ID = "199d9753-5605-4ed3-9daa-0cbde6c78716" as Uuid;

export const DULUX__EVENT__APPOINTMENT__EVENT_OWNER__COLUMN_ID = "ff8fcfea-8804-4391-94fb-96f07e35e791" as Uuid;

export const DULUX__EVENT__APPOINTMENT__SCHEDULE_DATE__COLUMN_ID = "a388d4d6-7267-4471-b2cb-cc9ad0f9d2d1" as Uuid;

export const DULUX__EVENT__APPOINTMENT__LOGGED_DATE__COLUMN_ID = "306427be-ca6e-411e-b7ff-ab86c7e56738" as Uuid;

export const DULUX__EVENT__APPOINTMENT__CANCELLED_BY__COLUMN_ID = "8cb64d16-5e14-4313-9822-d91d9150c305" as Uuid;

export const DULUX__EVENT__APPOINTMENT__CANCELLED_DATE__COLUMN_ID = "c1248d22-140b-4ec7-881e-b4b183c41d02" as Uuid;

export const DULUX__EVENT__APPOINTMENT__CANCELLATION_REMARKS__COLUMN_ID = "23d7d923-548d-4a25-a081-098923e688e7" as Uuid;

export const DULUX__EVENT__APPOINTMENT__LOGGED_REMARKS__COLUMN_ID = "0ed1c965-30fd-4d8d-b149-a4a16239809a" as Uuid;

export enum SalesStatusEnum {
    OPEN = "63eb4b8e-5cbf-42ca-b0a9-30742b825163",
    CLOSED = "e9fcf464-49a5-4fd4-9167-ee565561d4c9",
}

export enum EnquiryStatusEnum {
    NEW = "2116d233-107c-4f4e-9cc0-52ab7e312de4",
    DUPLICATE = "21017ee4-ab5d-4652-97ba-c348715350e8",
}

export enum OnboardingStatusEnum {
    NOT_ONBOARDED = "a33c45f2-6bfd-4660-8f59-cb5bd752a91e",
    ONBOARDED = "da40ea60-3208-46fd-ac44-0f17b873be8b",
}

export enum CallStatusEnum {
    SCHEDULED = "fe5e6687-9119-46c3-865c-9316f3c51c5b",
    LOGGED = "df327fac-5007-46a9-948e-06000452180c",
    CANCELLED = "6d2f52c9-84ab-4390-8fbb-423c09dc8002",
}

export enum AppointmentStatusEnum {
    SCHEDULED = "c53bd6b9-bcc7-4944-b429-d7c86ae6c0e7",
    LOGGED = "f36a2980-7857-4bd7-bfb9-ec5919632f37",
    CANCELLED = "769deb7f-2a78-45bf-b674-25fc7c8e241f",
}

export const DULUX__CALL__SCHEDULE__FORM__ID = "03cb447f-76ed-4ac6-9774-2c7c42d41a7f" as Uuid;

export const DULUX__CALL__LOG__FORM__ID = "736e90fe-0353-46c6-8d6b-f475917e9c9a" as Uuid;

export const DULUX__CALL__EDIT__FORM__ID = "89f6215e-aa07-4d8f-aa48-11199a691612" as Uuid;

export const DULUX__APPOINTMENT__SCHEDULE__FORM__ID = "51c7f617-f615-46a7-884f-6f8db88f7c0d" as Uuid;

export const DULUX__APPOINTMENT__LOG__FORM__ID = "56df8825-f391-4250-8469-9950232f33ee" as Uuid;

export const DULUX__APPOINTMENT__EDIT__FORM__ID = "02d1f8c2-95a4-47be-bddf-76a026c29c70" as Uuid;

export enum EnquiryTypeEnum {
    HOT = "84c178fc-e544-4000-9577-74d3af8d8143",
    WARM = "e40c6c12-7a27-4598-9118-726af942096c",
    COLD = "5c1fd591-6aaf-4514-838b-13755cba39a7",
}

export const logCallButtonId = "1359b79c-3b3e-4922-be36-22371deb0ad3" as Uuid;

export const salesStatuses: Record<SalesStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [SalesStatusEnum.OPEN]: {
        id: "63eb4b8e-5cbf-42ca-b0a9-30742b825163" as Uuid,
        displayName: "Open"
    },
    [SalesStatusEnum.CLOSED]: {
        id: "e9fcf464-49a5-4fd4-9167-ee565561d4c9" as Uuid,
        displayName: "Closed"
    },
};

export const enquiryStatuses: Record<EnquiryStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [EnquiryStatusEnum.NEW]: {
        id: "2116d233-107c-4f4e-9cc0-52ab7e312de4" as Uuid,
        displayName: "New"
    },
    [EnquiryStatusEnum.DUPLICATE]: {
        id: "21017ee4-ab5d-4652-97ba-c348715350e8" as Uuid,
        displayName: "Duplicate"
    },
};

export const enquiryTypes: Record<EnquiryTypeEnum, {
    id: Uuid,
    displayName: string
}> = {
    [EnquiryTypeEnum.HOT]: {
        id: "84c178fc-e544-4000-9577-74d3af8d8143" as Uuid,
        displayName: "Hot"
    },
    [EnquiryTypeEnum.WARM]: {
        id: "e40c6c12-7a27-4598-9118-726af942096c" as Uuid,
        displayName: "Warm"
    },
    [EnquiryTypeEnum.COLD]: {
        id: "5c1fd591-6aaf-4514-838b-13755cba39a7" as Uuid,
        displayName: "Cold"
    },
};

export const onboardingStatuses: Record<OnboardingStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [OnboardingStatusEnum.NOT_ONBOARDED]: {
        id: "a33c45f2-6bfd-4660-8f59-cb5bd752a91e" as Uuid,
        displayName: "Not Onboarded"
    },
    [OnboardingStatusEnum.ONBOARDED]: {
        id: "da40ea60-3208-46fd-ac44-0f17b873be8b" as Uuid,
        displayName: "Onboarded"
    },
};

export const callStatuses: Record<CallStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [CallStatusEnum.SCHEDULED]: {
        id: "fe5e6687-9119-46c3-865c-9316f3c51c5b" as Uuid,
        displayName: "Scheduled"
    },
    [CallStatusEnum.LOGGED]: {
        id: "df327fac-5007-46a9-948e-06000452180c" as Uuid,
        displayName: "Logged"
    },
    [CallStatusEnum.CANCELLED]: {
        id: "6d2f52c9-84ab-4390-8fbb-423c09dc8002" as Uuid,
        displayName: "Cancelled"
    },
};

export const appointmentStatuses: Record<AppointmentStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    [AppointmentStatusEnum.SCHEDULED]: {
        id: "c53bd6b9-bcc7-4944-b429-d7c86ae6c0e7" as Uuid,
        displayName: "Scheduled"
    },
    [AppointmentStatusEnum.LOGGED]: {
        id: "f36a2980-7857-4bd7-bfb9-ec5919632f37" as Uuid,
        displayName: "Logged"
    },
    [AppointmentStatusEnum.CANCELLED]: {
        id: "769deb7f-2a78-45bf-b674-25fc7c8e241f" as Uuid,
        displayName: "Cancelled"
    },
};
